import { render, staticRenderFns } from "./GenotypeExportSelection.vue?vue&type=template&id=f4b41e02&"
import script from "./GenotypeExportSelection.vue?vue&type=script&lang=js&"
export * from "./GenotypeExportSelection.vue?vue&type=script&lang=js&"
import style0 from "./GenotypeExportSelection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports